import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { minutesToMilliseconds } from 'date-fns';
import { useState } from 'react';
import { useParams } from 'react-router';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';

import { RootContainer } from '../../components/nav/RootContainer';
import { OrderDetailsCard } from './components/OrderDetailsCard';

export function OrderDetails() {
    const { id } = useParams();
    const activePage = useActivePage();
    const [pickupDetailsExpanded, setPickupDetailsExpanded] = useState(false);
    const [faceVerificationExpanded, setFaceVerificationExpanded] =
        useState(false);

    const orderQueryResults = useQuery({
        queryKey: ['order', id],
        queryFn: () => Api.Orders.Order.getOrderById(Number(id)),
    });

    const imageUrlsQuery = useQuery({
        queryKey: ['order-image-urls', id],
        queryFn: () => Api.Orders.Order.getOrderImageUrls(Number(id)),
        enabled: pickupDetailsExpanded || faceVerificationExpanded,
        staleTime: minutesToMilliseconds(25), // signed URLs expire in 30 min
        refetchOnWindowFocus: true,
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        { title: 'Details', path: `${activePage?.path}/${id}` },
    ];

    return (
        <RootContainer
            maxWidth={false}
            breadcrumbs={breadcrumbs}
            title="Order Details"
        >
            <QueryRenderer results={orderQueryResults}>
                {data => (
                    <OrderDetailsCard
                        order={data}
                        imageUrls={imageUrlsQuery.data?.data}
                        imageUrlsLoading={imageUrlsQuery.isLoading}
                        pickupDetailsExpanded={pickupDetailsExpanded}
                        onPickupDetailsExpandedChange={setPickupDetailsExpanded}
                        faceVerificationExpanded={faceVerificationExpanded}
                        onFaceVerificationExpandedChange={
                            setFaceVerificationExpanded
                        }
                    />
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
